<template>
  <section
    class="container-sarah"
    v-if="this.PacienteFalecido"
  >
    <InformacaoAcao
      :mensagem="this.$t('home.erro-fale-chat')"
      :texto-botao="this.$t('botoes.chat')"
      :botao="true"
      @botaoClick="abrirChat()"
    />
  </section>
  <section
    class="container-sarah"
    v-else
  >
    <JornadaPaciente />
    <div v-if="paciente">
      <notification v-if="paciente.TemSolicitacao" />
      <card-menu
        :profile="paciente.Perfil"
        :internado="this.PacienteInternado"
      />
      <hr />
      <InformacaoAcao
        :mensagem="this.$t('home.mensagem-internado')"
        :botao="false"
        v-if="this.PacienteInternado"
      />
      <RecentlyOperated v-if="paciente.Perfil === 'Procedimento'" />
      <FastCards v-if="!this.PacienteInternado" />
      <optin-modal
        v-if="paciente"
        :paciente="paciente"
      />
    </div>
  </section>
</template>

<script>
import CardMenu from '../components/home/CardMenu'
import Notification from '../components/home/Notification'
import JornadaPaciente from '../components/home/JornadaPaciente'
import RecentlyOperated from '../components/home/profiles/RecentlyOperated'
import InformacaoAcao from '../components/home/InformacaoAcao'
import FastCards from '../components/home/fastcards/FastCards'
import OptinModal from '../components/shared/modal/OptinModal.vue'
import router from '@/router'

import { mapGetters } from 'vuex'
export default {
  name: 'HomePage',
  components: {
    'card-menu': CardMenu,
    FastCards,
    Notification,
    RecentlyOperated,
    InformacaoAcao,
    JornadaPaciente,
    OptinModal
  },
  beforeMount () {
    this.VerificarUsuario()
  },
  methods: {
    VerificarUsuario () {
      if (this.paciente == null) {
        router.push('/')
      }
    },
    abrirChat () {
      window.open('http://www.sarah.br/chat')
    }
  },
  computed: {
    ...mapGetters({
      paciente: 'dadosPaciente'
    }),
    PacienteFalecido () {
      return this.paciente && this.paciente.Falecido === 'S'
    },
    PacienteInternado () {
      return this.paciente && this.paciente.Internado === 'S'
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/stylesheets/styleguide";
.menu {
  padding-top: 1.84375rem;
  padding-left: 1.5625rem;
  padding-right: 1.5625rem;
}

hr {
  box-sizing: border-box;
  border: 0;
  border-top: 1px solid $neutral-color-4;
  border-color: var(--neutral-color-4);
}
</style>
